// Identifiants publics des entreprises et des comptes. Ce ne sont pas des
// identifiants de connexion : l'appli n'en stocke aucun.

/**
 * SIREN : 9 chiffres, clé de Luhn. (L'exception de La Poste porte sur le SIRET,
 * pas sur le SIREN 356000000, qui respecte la clé.)
 */
export function sirenValide(siren: string): boolean {
  if (!/^\d{9}$/.test(siren)) return false
  const chiffres = [...siren].map(Number)
  let somme = 0
  chiffres.forEach((c, i) => {
    // En partant de la droite, un chiffre sur deux est doublé (indices impairs depuis la gauche).
    const v = i % 2 === 1 ? c * 2 : c
    somme += v > 9 ? v - 9 : v
  })
  return somme % 10 === 0
}

export function normaliserIban(iban: string): string {
  return iban.replace(/\s+/g, '').toUpperCase()
}

/** IBAN : format et clé modulo 97. */
export function ibanValide(iban: string): boolean {
  const n = normaliserIban(iban)
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(n)) return false
  const reordonne = n.slice(4) + n.slice(0, 4)
  let reste = 0
  for (const car of reordonne) {
    const valeur = /\d/.test(car) ? car : String(car.charCodeAt(0) - 55)
    for (const chiffre of valeur) reste = (reste * 10 + Number(chiffre)) % 97
  }
  return reste === 1
}
